export type Batch = {
  arrived: string
  name: string
  received: number
  msrp?: number
  estimatedRecovery?: number
  lineItems?: number
}

export const onePeopleIncomingBatches: Batch[] = [
  { arrived: 'Feb 5, 2026', name: 'Spring overstock', received: 1267 },
  { arrived: 'Dec 6, 2025', name: 'Assembly part 4', received: 7 },
  { arrived: 'Aug 30, 2025', name: 'August returns', received: 335 },
  { arrived: 'Jul 10, 2025', name: 'July overstock', received: 16 },
  { arrived: 'May 2, 2025', name: 'May overstock', received: 258 },
]

export const eddyIncomingBatches: Batch[] = [
  { arrived: 'Nov 4, 2026', name: 'Eddy — January 3PL transfer', received: 86 },
  { arrived: 'Jan 28, 2026', name: 'Eddy Samples', received: 0 },
  { arrived: 'Dec 16, 2025', name: 'Eddy — December 2025 3PL transfer', received: 1105 },
  { arrived: 'Nov 21, 2025', name: 'Eddy 3PL transfer', received: 120 },
  { arrived: 'Oct 10, 2025', name: 'Eddy 3PL Transfer', received: 86 },
  { arrived: 'May 22, 2025', name: 'Eddy — TJX Overflow', received: 223 },
  { arrived: 'May 19, 2025', name: 'Eddy — 3PL Transfer', received: 845 },
  { arrived: 'Sep 30, 2024', name: 'Eddy — October 3PL Transfer', received: 25 },
  { arrived: 'Aug 13, 2024', name: 'Eddy — Fall 2024', received: 169 },
  { arrived: 'Apr 8, 2024', name: 'Eddy April 2024', received: 0 },
  { arrived: 'Jan 18, 2024', name: 'Eddy — Jan 2024', received: 0 },
  { arrived: 'Dec 20, 1905', name: 'Eddy — 3PL transfer old', received: 183 },
  { arrived: '—', name: 'Eddy — June TRX', received: 139 },
  { arrived: '—', name: 'Eddy — 3PL Transfer', received: 0 },
]

// Batch names repeat within a brand, so the index keeps each id unique.
export function submissionId(brand: string, index: number, name: string) {
  return `${brand}::${index}::${name}`
}
